<template>
    <div class="tw:pt-bs-3">
        <ul class="tw:flex tw:items-center tw:justify-center tw:gap-1 tw:list-none tw:m-0 tw:p-0 tw:mb-bs-0">
            <!-- Boton nga Agsubli (Anterior) -->
            <li>
                <button type="button"
                    class="tw:flex tw:items-center tw:justify-center tw:px-3 tw:py-1.5 tw:rounded-lg tw:border tw:border-slate-200 tw:bg-white tw:text-xs tw:text-slate-600 tw:transition-all disabled:tw:opacity-40 disabled:tw:cursor-not-allowed hover:tw:bg-slate-50 hover:tw:border-slate-300"
                    :disabled="page.current_page <= 1" @click="changePage(page.current_page - 1)">
                    <i class="fa fa-arrow-left"></i>
                </button>
            </li>

            <!-- Dagiti Numero ti Panid -->
            <li v-for="paginate in pagesNumber" :key="paginate">
                <button type="button"
                    class="tw:flex tw:items-center tw:justify-center tw:min-w-[32px] tw:h-8 tw:px-3 tw:rounded-lg tw:border tw:text-xs tw:font-medium tw:transition-all tw:cursor-pointer"
                    :class="paginate === page.current_page
                        ? 'tw:bg-brand-primary tw:border-brand-primary tw:text-white tw:shadow-sm'
                        : 'tw:bg-white tw:border-slate-200 tw:text-slate-700 hover:tw:bg-slate-50 hover:tw:border-slate-300'"
                    @click="changePage(paginate)">
                    {{ paginate }}
                </button>
            </li>

            <!-- Boton nga Agiyuneg (Siguiente) -->
            <li>
                <button type="button"
                    class="tw:flex tw:items-center tw:justify-center tw:px-3 tw:py-1.5 tw:rounded-lg tw:border tw:border-slate-200 tw:bg-white tw:text-xs tw:text-slate-600 tw:transition-all disabled:tw:opacity-40 disabled:tw:cursor-not-allowed hover:tw:bg-slate-50 hover:tw:border-slate-300"
                    :disabled="page.current_page >= page.last_page" @click="changePage(page.current_page + 1)">
                    <i class="fa fa-arrow-right"></i>
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "TablePagination",
    props: {
        page: {
            type: Object,
            required: true
        },
        offset: {
            type: Number,
            default: 4
        }
    },
    computed: {
        pagesNumber() {
            if (!this.page.to) {
                return [];
            }
            let from = this.page.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + (this.offset * 2);
            if (to >= this.page.last_page) {
                to = this.page.last_page;
            }
            let pagesArray = [];
            for (let i = from; i <= to; i++) {
                pagesArray.push(i);
            }
            return pagesArray;
        }
    },
    methods: {
        changePage(item) {
            if (item < 1 || item > this.page.last_page || item === this.page.current_page) {
                return;
            }
            this.$emit('paginate', item);
        }
    }
}
</script>